<template>
    <transition name="fade" mode="out-in">
        <router-view :user="user"/>
    </transition>
</template>

<script>
    export default {
        name: "Wrapper",
        data: () => ({
            user: {
                id: null,
                photo: null,
                name: null,
                country: 'PER',
                role: 'Customer',
                office_id: null,
                account_id: null,
                status: null,
                suspendReason: null
            }
        })
    }
</script>

<style scoped>

</style>
